<template>
  <basic-card class="global-basic-card" padding hideHeader>
    <avue-crud
      class="global-table"
      :key="tableKey"
      :option="option"
      v-model:search="search"
      v-model:page="page"
      v-model="form"
      :table-loading="loading"
      :data="data"
      :permission="permissionObj"
      :before-open="beforeOpen"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #datetimerange-search>
        <div class="block">
          <el-date-picker
            v-model="dateTimeRange"
            type="datetimerange"
            :default-time="[$dayjs(new Date()).startOf('day'), $dayjs(new Date()).endOf('day')]"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            range-separator="-"
            :start-placeholder="Lang.Title.alarmRecStartTime"
            :end-placeholder="Lang.label.endTime"
            style="width: 94%;"
            >
          </el-date-picker>
        </div>
      </template>
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <!-- <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button> -->
          </div>
          <div></div>
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <compTabs
            :defaultIndex="0"
            :options="[
              { label: Lang.label.warning, value: 1 },
              { label: Lang.label.historicalAlarms, value: 0 },
            ]"
            @change="handleTabChange"
          />
          <div class="global-barrier"></div>
          <comp-button
            type="info"
            icon="erase"
            isSvgIcon
            :loading="loading"
            :prefixIconStyle="{ 'margin-right': '4px' }"
            v-if="permissionObj.clear && warningType == 1" 
            @click="handleReduce"
            >{{ Lang.Button.alarmRecClear }}
          </comp-button>
          <comp-button
            type="info"
            icon="up-export"
            isSvgIcon
            :loading="loading"
            :prefixIconStyle="{ 'margin-right': '4px' }"
            v-if="permissionObj.export" 
            @click="handleExport"
            >{{ Lang.btn.export }}
          </comp-button>
          <!-- <div class="refresh">
            <comp-svg name="refresh-fill" size="16px" style="color:#fff;"></comp-svg>
          </div> -->
        </div>
      </template>
      <template #alarmLevel="{ row }" align="left">
        <div style="width: max-content;">
          <div v-if="row.alarmLevel == 2" class="danger-tag">
            <comp-svg name="critical"></comp-svg>
            {{ row.alarmLevelName }}
          </div>
          <div v-else-if="row.alarmLevel == 3" class="emergence-tag">
            <comp-svg name="emergency"></comp-svg>
            {{ row.alarmLevelName }}
          </div>
          <div v-else class="primary-tag">
            <comp-svg name="important"></comp-svg>
            {{ row.alarmLevelName }}
          </div>
        </div>
      </template>
      <template #handleTypeName="{row}" >
        <span style="display: flex;align-items: center;">
          <span>{{ row.handleTypeName }}</span>
          <CompIconButton v-if="row.handleUserName" icon="info" :authorize="true" :text="row.handleUserName" :divider="false" :size="16" />
        </span>
      </template>
      <!-- 操作菜单按钮 -->
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="clear" icon="erase" :text="Lang.Button.alarmRecClear" :divider="false" @click="handleReduceSingle(scope.row)" > </CompIconButton>
        </div>
      </template>
    </avue-crud>
  </basic-card>
</template>

<script>
import { getPage, getList, getDetail, add, update, remove, handleReduce } from '@/api/alarmevent/alarmEvent';
import { mapGetters } from 'vuex';
import { exportBlob } from '@/api/common';
import { getToken } from '@/utils/auth';
import { downloadXls } from '@/utils/util';
import { download } from '@/axios';
import { dateNow } from '@/utils/date';
import func from '@/utils/func';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { alarmLevels } from '@/const/options';
import compTabs from '@/components/comp-tab/index.vue';
import { filterDollarKeys } from '@/utils/util';
import { method } from 'lodash';

export default {
  components: {
    compTabs,
  },
  data() {
    return {
      dateTimeRange: [],
      tableKey: 0,
      warningType: 0,
      form: {},
      query: {},
      search: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      showMore: true,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        menuWidth: 60, // 操作列宽
        menuType: 'button',
        menuTitle: this.Lang.Title.alarmRecAction,
        menuHeaderAlign: 'right', // 操作按钮样式
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchLabelWidth: 'auto',
        searchLabelPosition: 'left',
        searchMenuSpan: 'auto',
        searchMenuSpan: 4,
        searchMenuPosition: 'right',
        border: false,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        viewBtn: false,
        delBtn: false,
        addBtn: false,
        emptyBtn: false,
        menu: true,
        searchBtn: false,
        selection: true,
        dialogType: 'drawer',
        dialogClickModal: false,
        gutter: 20,
        editBtnText: this.Lang.btn.ignore,
        editBtn: false,
        searchGutter: 20,
        dialogMenuPosition: 'center', // 弹窗按钮位置
        labelWidth: 'auto',
        labelPosition: 'top',
        searchLabelPosition: 'top',
        showOverflowTooltip: true,
        searchLabelSuffix: ' ',
        column: [
        {
            label: this.Lang.Title.alarmRecDeviceName,
            prop: 'deviceName',
            type: 'input',
            search: false,
            searchPlaceholder: this.Lang.label.plzInputGateway
          },
          {
            label: this.Lang.Title.alarmRecAlarmLevel,
            prop: 'alarmLevel',
            type: 'select',
            dicData: alarmLevels,
            search: false,
            searchPlaceholder: this.Lang.label.PleaseselectAlarmlevel,
          },
          {
            label: this.Lang.Title.alarmRecAlarmContent,
            width: 400,
            prop: 'alarmContent',
          },
          {
            label: this.Lang.Title.alarmRecAlarmTime,
            prop: 'datetimerange',
            type: 'datetimerange',
            search: true,
            searchSpan: 6,
            searchPlaceholder: this.Lang.tips.plzSelectStartTime,
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            slot: 'datetimerange-search', 
          },
          {
            label: this.Lang.Title.alarmRecAlarmTime,
            prop: 'startTime',
            type: 'datetime',
            search: false,
            searchPlaceholder: this.Lang.tips.plzSelectStartTime,
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
          },
          // {
          //   label: this.Lang.label.endTime,
          //   prop: 'endTime',
          //   type: 'datetime',
          //   search: true,
          //   searchPlaceholder: this.Lang.tips.plzSelect+' '+this.Lang.label.endTime,
          //   format: 'YYYY-MM-DD HH:mm:ss',
          //   valueFormat: 'YYYY-MM-DD HH:mm:ss',

          // },
          {
            label: this.Lang.Title.alarmRecDeviceName,
            prop: 'deviceName',
            dProp: 'deviceNameB',
            type: 'input',
            search: false,
            hide: true,
            searchPlaceholder: this.Lang.label.plzInputGateway
          },

          {
            label: this.Lang.Title.alarmRecAlarmLevel,
            prop: 'alarmLevel',
            dProp: 'alarmLevel',
            type: 'select',
            dicData: alarmLevels,
            search: true,
            hide: true,
            searchPlaceholder: this.Lang.label.PleaseselectAlarmlevel,
          },
          
          {
            label: this.Lang.Title.alarmRecClearTime,
            prop: 'endTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
          },
          {
            label: this.Lang.Title.alarmRecDeviceName,
            prop: 'deviceName',
            dProp: 'deviceNameC',
            type: 'input',
            search: true,
            hide: true,
            display: false,
            searchPlaceholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.alarmRecDeviceName,
          },
          {
            label: this.Lang.Title.alarmRecDeviceSn,
            prop: 'sn',
            type: 'input',
            search: true,
          },
          {
            label: this.Lang.Title.alarmRecDeviceType,
            prop: 'iotProductName',
            type: 'input',
            search: false,
          },
          {
            label: this.Lang.Title.alarmRecOrg,
            prop: 'deptName',
            type: 'input',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: false,
          },
          {
            label: this.Lang.Title.alarmRecClearType,
            prop: 'handleTypeName',
            type: 'input',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    handleTabChange(i, item) {
      this.warningType = item.value;
      if (item.value === 0) {
        this.option.menu = false;
        this.option.column.forEach(item => {
          if (['deviceName','alarmLevel','alarmContent','startTime','alarmLevel','endTime','sn','deptName', 'iotProductName', 'handleTypeName'].includes(item.prop)) {
            if (item.dProp) {
              item.hide = true;
            } else {
              item.hide = false;
            }
          } else {
            item.hide = true;
          }
        })
        this.searchHistoryAlarms();
      } else {
        this.option.menu = true;
        this.option.column.forEach(item => {
          if (['deviceName','alarmLevel','alarmContent','startTime','alarmLevel','sn','iotProductName','deptName'].includes(item.prop)) {
            if (item.dProp) {
              item.hide = true;
            } else {
              item.hide = false;
            }
          } else {
            item.hide = true;
          }
        })
        this.searchAlarming();
      }
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search);
      const params = filterDollarKeys(this.search);
      this.onLoad(this.page, params);
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义删除
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleReduceSingle(row) {
      this.$dialog({
        title: this.Lang.Title.alarmRecAlarmClear,
        content: this.Lang.Text.alarmRecAlarmClearCon,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        confirmButtonType: 'primary',
        cancelButtonType: 'default',
      })
        .then(() => {
          return handleReduce(row.id, 1);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$store.dispatch('GetAlarmingCount');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleReduce() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$dialog({
        title: this.Lang.Title.alarmRecAlarmClear,
        content: this.Lang.Text.alarmRecAlarmClearCon,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
      })
        .then(() => {
          return handleReduce(this.ids, 1);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$store.dispatch('GetAlarmingCount');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    // 搜索历史告警
    searchHistoryAlarms() {
      const params = { alarmStatus: 0 };
      this.onLoad(this.page, params);
    },
    // 搜索正在告警
    searchAlarming() {
      const params = { alarmStatus: 1 };
      this.onLoad(this.page, params);
    },
    // 忽略
    handleIgnore() {},
    // 工单处理
    handleOrder() {},

    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          loading();
          window.console.log(error);
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          loading();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$dialog({
        title: this.Lang.Title.alarmRecAlarmClear,
        content: this.Lang.Text.alarmRecAlarmClearCon,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleExport() {
      let url = `/emp-business/alarmEvent/export-alarmEvent/apiDownload?${
        this.website.tokenHeader
      }=${getToken()}`;
      const { deviceName, rtuName, alarmLevel, projectName } = this.query;
      const startTime = this.dateTimeRange[0] ? this.dateTimeRange[0] : '';
      const endTime = this.dateTimeRange[1] ? this.dateTimeRange[1] : '';
      let params = {
        deviceName: deviceName,
        rtuName: rtuName,
        alarmLevel: alarmLevel,
        projectName: projectName,
        startTime: startTime,
        endTime: endTime,
        alarmStatus: this.warningType,
      };
      this.$confirm(this.Lang.tips.ifExportData, this.Lang.label.tips, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      }).then(() => {
        NProgress.start();
        this.loading = true;
        
        download({url, params}).then(res => {
          this.loading = false;
          NProgress.done();
        });
      });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud?.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      console.log(this.dateTimeRange)
      const query = Object.assign(this.query, params);
      const dateTimeRange = this.dateTimeRange || [];
      query.startTime = dateTimeRange[0] ? dateTimeRange[0] : '';
      query.endTime = dateTimeRange[1] ? dateTimeRange[1] : '';
      getPage(page.currentPage, page.pageSize, query).then(res => {
        const data = res.data.data || {};
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
